export default function prioritizeHeroNews(news) {
  const isBatteryShow = ({ fields }) =>
    [fields.Titel, fields.Titel_EN].some(
      (title) => typeof title === "string" && /battery\s+show/i.test(title)
    );

  return [
    ...news.filter(isBatteryShow),
    ...news.filter((item) => !isBatteryShow(item)),
  ];
}
